import { React, useEffect, useState } from 'react';
import { Row, Col, Button, Spin, message, Form, Tag, List, Radio, Calendar } from 'antd';
import dayjs from 'dayjs';
import { useNavigate, useParams, } from 'react-router-dom'
import SystemHolidayDetailPicker from './SystemHolidayDetailPicker';
import { useSystemHoliday } from '../Controller/useSystemHolidayController';

const SystemHolidayDetailOverView = () => {
    const { holiday_setting_id } = useParams()
    const [loading, set_loading] = useState(0);
    const [holidayDatas, setHolidayDatas] = useState([])
    const [moreHolidayDatas, setMoreHolidayDatas] = useState([])
    const [defaultValue, setDefaultValue] = useState()
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState("get")
    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true);
        // getBillPaymentClassData({
        //     cur_page: param?.current,
        //     size: param?.pageSize,
        // })
    }
    const reload = () => {
        getSystemHolidaySettingData({
            holiday_setting_id: holiday_setting_id
        })
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "patch") {
                message.success("修改成功")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "patch") {
                message.error("修改失敗")
                reload()
            }
            setModalLoading(false)
            setModalOpen(false)
        }
        console.log("end")
        setModalLoading(false)

    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }
    const {
        systemHolidaySettingDatas,
        getSystemHolidaySettingData,
        patchSystemHolidaySettingData
    } = useSystemHoliday({
        onBefore: onBefore,
        onFinish: onFinish
    })
    const save = () => {
        let data = [
            {
                ...defaultValue,
                holiday_setting_holiday_data: holidayDatas,
                else_holiday_data: moreHolidayDatas
            }
        ]
        patchSystemHolidaySettingData(data)
    }
    useEffect(() => {
        getSystemHolidaySettingData({
            holiday_setting_id: holiday_setting_id
        })
    }, [])
    useEffect(() => {
        let firstData = systemHolidaySettingDatas.find((ele) => true)
        let holiday_setting_holiday_data = firstData?.holiday_setting_holiday_data || []
        let else_holiday_data = firstData?.else_holiday_data || []
        setDefaultValue(firstData)
        setHolidayDatas(holiday_setting_holiday_data)
        setMoreHolidayDatas(else_holiday_data)
    }, [systemHolidaySettingDatas])
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Spin spinning={modalLoading}>
                    <Row gutter={[8, 16]} justify={'space-between'}>
                        <Col span={24} />
                        <Col span={24}>
                            <Row>
                                <Col span={10}>
                                    年度:{defaultValue?.holiday_setting_year}-01-01 ~{defaultValue?.holiday_setting_year}-12-30
                                </Col>
                                <Col span={10}>
                                    此年度共有{holidayDatas.filter(tmp => tmp.isholiday === "true").length + moreHolidayDatas.length}天假日
                                </Col>
                                <Col span={4}>
                                    <Button
                                        type='primary'
                                        onClick={() => save()}
                                    >
                                        儲存
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <SystemHolidayDetailPicker
                                year={defaultValue?.holiday_setting_year}
                                holidayDatas={holidayDatas}
                                moreHolidayDatas={moreHolidayDatas}
                                setHolidayDatas={setHolidayDatas}
                                setMoreHolidayDatas={setMoreHolidayDatas}
                            />
                        </Col>
                    </Row>
                </Spin>
            </Col>
        </Row>
    )
}
export default SystemHolidayDetailOverView; 
